import { useIntl } from 'react-intl';

import './styles.css';

export default function Header() {
    const intl = useIntl();

    return (
        <header className='aeg-header-root display-flex align-items-center gap-10 margin-bottom-10'>
            <div>
                <span className='display-block text-size-12 text-medium text-color-dark'>
                    {intl.formatMessage({ id: 'intl-msg:support.aeg.page.breadcrumb' })}
                </span>
                <h1 className='margin-0 text-bold text-color-darkest'>{intl.formatMessage({ id: 'intl-msg:support.aeg.page.title' })}</h1>
            </div>
        </header>
    );
}
